//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        zIndex: Number
    },
    methods: {
        searchClick() {
            this.$emit('searchClick')
        },
        openMap () {
            this.$router.push({
                path: '/map_buildings'
            })
        }
    }
}
